import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// Module
import { AuthorizationModule } from './authorization/auth.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { OAuthModule } from 'angular-oauth2-oidc';
import { NgIdleModule } from '@ng-idle/core';
import { CoreModule } from './core/core.module';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { HttpCallInterceptor } from './core/services/http/interceptor/http-interceptor';
import { DatePipe } from '@angular/common';

// Services
import { GlobalErrorHandlerService } from './core/services/global-error-handler/global-error-handler.service';

@NgModule({
  declarations: [AppComponent, DisclaimerComponent],
  imports: [
  BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    AuthorizationModule,
    OAuthModule.forRoot(),
    NgIdleModule.forRoot(),
    CoreModule
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: HttpCallInterceptor,
    multi: true,
  },
  {
    provide: ErrorHandler,
    useClass: GlobalErrorHandlerService
  },
    DatePipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
